/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { protectedSymmetricKeySchema } from "./protectedSymmetricKeySchema.ts"
import { z } from "zod/v4"

export const ciphersSchema = z.object({
  get protectedUserSymmetricKey() {
    return protectedSymmetricKeySchema.describe(
      "A protected symmetric key is one that is base64 encoded and contains the initialization vector and the ciphertext",
    )
  },
  get protectedProfileSymmetricKey() {
    return protectedSymmetricKeySchema.describe(
      "A protected symmetric key is one that is base64 encoded and contains the initialization vector and the ciphertext",
    )
  },
  protectedRsaPrivateKey: z.string().min(1),
  rsaPublicKey: z.string().min(1),
})
